import React, { Component } from 'react';
import { Grid, Segment, Button, Icon, Table, Menu, Tab, Header, Modal } from 'semantic-ui-react';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import { getConsumePaymentsById } from '../../utils/rest';
import Documents from './Documents';
class History extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showHide: [],
            expanded: {},
            paymentexpanded: {},
            openDocument: false,
            documentAccountId: 0
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (nextProps.consumerAccounts.length !== this.props.consumerAccounts.length
            || nextProps.consumerHistory.length !== this.props.consumerHistory.length
            || nextProps.dialerHistory.length !== this.props.dialerHistory.length
            || nextProps.paymentsHistory.length !== this.props.paymentsHistory.length
            || nextState.expanded !== this.state.expanded
            || nextState.paymentexpanded !== this.state.paymentexpanded
            || nextState.openDocument !== this.state.openDocument)
    }

    getConsumePaymentsByPaymentId = (conConsumerId, payPaymentId, paymentexpanded) => {
        getConsumePaymentsById(this.props.items.currentCorporate, conConsumerId, payPaymentId).then((response) => {
            if (response !== null) {
                let paymentTransactions = {
                    ["PAY" + payPaymentId]: response.map((pat) => {
                        // eslint-disable-next-line
                        this.props.consumerAccounts.find((account) => {
                            if (account.acoAccountId === pat.patAcoAccountId) {
                                pat.acoInvoiceId = account.acoInvoiceId;
                                return true;
                            }
                        });
                        return pat;
                    })
                };
                this.props.addItem("paymentTransactions", Object.assign(this.props.items.paymentTransactions, paymentTransactions));
                this.setState({
                    paymentexpanded
                });
            }
        });
    }

    openDocument = (acoAccountId) => {
        this.setState({
            openDocument: true,
            documentAccountId: acoAccountId
        })
    }

    closeDocument = () => {
        this.setState({
            openDocument: false
        })
    }

    render() {
        const panes = [
            {
                menuItem: (
                    <Menu.Item key='title1'>
                        Account Details
                    </Menu.Item>
                ), pane: {
                    key: 'first', content: (
                        <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.props.consumerAccounts && this.props.consumerAccounts.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                            data={this.props.consumerAccounts}
                            getNoDataProps={() => {
                                return { style: { display: 'none' } };
                            }}
                            onExpandedChange={(expanded, index, event) => {
                                this.setState({ expanded });
                            }}
                            expanded={this.state.expanded}
                            SubComponent={row => {
                                return (
                                    <Segment.Group horizontal >
                                        <Segment>
                                            <Table className="definition small">
                                                <Table.Body>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">Client:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{row.original.cltClientId + ' - ' + row.original.cltClientName}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">Client Acct#:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{row.original.acoInvoiceId}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">Our Acct#:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{row.original.acoAccountId}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">DOR:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{row.original.acoDor}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">For:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{row.original.acoAccountFor}</Table.Cell>
                                                    </Table.Row>
                                                </Table.Body>
                                            </Table>
                                        </Segment>
                                        <Segment>
                                            <Table className="definition small">
                                                <Table.Body>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">INT:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{this.props._currencyFormat(row.original.acoInterest)}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">DOS:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{row.original.acoDos}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">INT From:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{row.original.acoInterestStart}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">AR:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{this.props._currencyFormat(row.original.acoAmountReferred)}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">DLP:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{row.original.acoDlp}</Table.Cell>
                                                    </Table.Row>
                                                </Table.Body>
                                            </Table>
                                        </Segment>
                                        <Segment>
                                            <Table className="definition small">
                                                <Table.Body>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">INT Rate:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{this.props._currencyFormat(row.original.acoInterestRate)}%</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">PB:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{this.props._currencyFormat(row.original.acoPrincipal)}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">Credit Flag:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{row.original.acoCreditFlag}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">Status Code:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{row.original.acoStatusCode}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell className="six wide right aligned">Total:</Table.Cell>
                                                        <Table.Cell className="ten wide left aligned collapsing">{this.props._currencyFormat(row.original.acoTotal)}</Table.Cell>
                                                    </Table.Row>
                                                </Table.Body>
                                            </Table>
                                        </Segment>
                                    </Segment.Group>
                                );
                            }}
                            columns={[{
                                expander: true,
                                Header: props => <span data-inverted=""
                                    data-tooltip={this.props.t("view.account.details")}
                                    data-position="bottom left">#
                                </span>,
                                Expander: ({ isExpanded, ...rest }) =>
                                    <div>
                                        {
                                            isExpanded
                                                ? <Icon className="arrow alternate circle down icon"></Icon>
                                                : <Icon className="arrow alternate circle right icon"></Icon>
                                        }
                                    </div>,
                                style: {
                                    cursor: "pointer"
                                }
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Client ID" data-position="bottom left">Client ID</span>,
                                minWidth: 80,
                                Cell: row => (
                                    <span data-inverted="" data-tooltip={row.original.cltClientName} data-position="top left">{row.original.cltClientId}</span>                                    
                                )
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Client Account Number" data-position="bottom left">Client Acct#</span>,
                                accessor: 'acoInvoiceId',
                                minWidth: 100
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Our Agency's Account Number" data-position="bottom left">Our Acct#</span>,
                                accessor: 'acoAccountId',
                                width: 100
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Date of Referral" data-position="bottom left">DOR</span>,
                                accessor: 'acoDor',
                                width: 88
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Date of Service" data-position="bottom left">DOS</span>,
                                accessor: 'acoDos',
                                width: 88
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Date of Last Payment" data-position="bottom left">DLP</span>,
                                accessor: 'acoDlp',
                                width: 88
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Current Status of Account " data-position="bottom left">Status</span>,
                                accessor: 'acoStatusCode',
                                width: 60,
                                style: {
                                    textAlign: "center"
                                },
                            },{
                                Header: props => <span data-inverted="" data-tooltip="Account Currency Code" data-position="bottom left">Currency Code</span>,
                                accessor: 'currencyCode',
                                width: 100,
                                style: {
                                    textAlign: "center"
                                },
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Amount Referred" data-position="bottom left">AR</span>,
                                id: 'acoAmountReferred',
                                width: 100,
                                style: {
                                    textAlign: "right"
                                },
                                accessor: row => (
                                    this.props._currencyFormat(row.acoAmountReferred)
                                )
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Principal Balance" data-position="bottom left">PB</span>,
                                id: 'acoPrincipal',
                                width: 100,
                                style: {
                                    textAlign: "right"
                                },
                                accessor: row => (
                                    this.props._currencyFormat(row.acoPrincipal)
                                )
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Interest" data-position="bottom left">INT</span>,
                                id: 'acoInterest',
                                width: 70,
                                style: {
                                    textAlign: "right"
                                },
                                accessor: row => (
                                    this.props._currencyFormat(row.acoInterest)
                                )
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Other Charges" data-position="bottom left">OC</span>,
                                id: 'acoOtherCharges',
                                width: 70,
                                style: {
                                    textAlign: "right"
                                },
                                accessor: row => (
                                    this.props._currencyFormat(row.acoOtherCharges)
                                )
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Current Total Due" data-position="bottom left">Total</span>,
                                id: 'acoTotal',
                                width: 100,
                                style: {
                                    textAlign: "right"
                                },
                                accessor: row => (
                                    this.props._currencyFormat(row.acoTotal)
                                )
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Clickable Action Buttons" data-position="bottom right">{this.props.t("actions")}</span>,
                                filterable: false,
                                width: 160,
                                style: {
                                    textAlign: "center"
                                },
                                Cell: row => (
                                    <div>
                                        <Button.Group basic size='small'>
                                            <Button as={Link} to={"/payment/" + row.original.acoAccountId} className="icon mini" disabled={this.props._clientRestriction(this.props.items.clients, row.cltClientId, "allowedtopostpayment")} data-tooltip="Enter Payment & Adjustment" data-inverted="" data-position="top right" >Pay</Button>
                                            <Button as={Link} to={"/hold/" + row.original.acoAccountId} className="icon mini" disabled={this.props._clientRestriction(this.props.items.clients, row.cltClientId, "allowedtoholdaccount")} data-tooltip="Request a Hold" data-inverted="" data-position="top right"><Icon name="pause" /></Button>
                                            <Button as={Link} to={"/cancellation/" + row.original.acoAccountId} className="icon mini" disabled={this.props._clientRestriction(this.props.items.clients, row.cltClientId, "allowedtocancelaccount")} data-tooltip="Request Cancellation" data-inverted="" data-position="top right"><Icon name="exclamation triangle" /></Button>
                                            <Button onClick={() => { this.openDocument(row.original.acoAccountId) }} className="icon mini" data-tooltip="View/Upload Documents" data-inverted="" data-position="top right"><Icon name="folder open" /></Button>
                                        </Button.Group>
                                    </div>
                                )
                            }]}
                        />
                    )
                }
            },
            {
                menuItem: (
                    <Menu.Item key='title4'>
                        Payment Details
                    </Menu.Item>
                ), pane: {
                    key: 'fourth', content: (
                        <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize}
                            showPagination={this.props.paymentsHistory && this.props.paymentsHistory.length > this.props.reactTable().pageSize ? true : false}
                            filterable
                            defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                            data={this.props.paymentsHistory}
                            getNoDataProps={() => {
                                return { style: { display: 'none' } };
                            }}
                            collapseOnDataChange={false}
                            onExpandedChange={(expanded, index, event) => {
                                let rowInfo = this.props.paymentsHistory[index];
                                if (this.props.items.paymentTransactions["PAY" + rowInfo.payPaymentId] === undefined) {
                                    this.getConsumePaymentsByPaymentId(this.props.params.id, rowInfo.payPaymentId, expanded);
                                } else {
                                    this.setState({
                                        paymentexpanded: expanded
                                    });
                                }
                            }}
                            expanded={this.state.paymentexpanded}
                            SubComponent={
                                row => {
                                    let tranData = this.props.items.paymentTransactions["PAY" + row.original.payPaymentId] === undefined ? [] : this.props.items.paymentTransactions["PAY" + row.original.payPaymentId];
                                    return (
                                        <Segment.Group horizontal >
                                            <Segment>
                                                <ReactTable minRows={0} filterable
                                                    defaultPageSize={this.props.reactTable().pageSize}
                                                    showPagination={tranData.length > this.props.reactTable().pageSize ? true : false}
                                                    defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                                                    data={tranData}
                                                    key={row.original.payPaymentId}
                                                    getNoDataProps={() => {
                                                        return { style: { display: 'none' } };
                                                    }}
                                                    columns={[{
                                                        Header: props => <span data-inverted="" data-tooltip="Client Id" data-position="bottom left">Client ID</span>,
                                                        accessor: 'patCltClientId', // String-based value accessors!
                                                        width: 80,
                                                    }, {
                                                        Header: props => <span data-inverted="" data-tooltip="Our Agency's Account Number" data-position="bottom left">Our Acct#</span>,
                                                        accessor: 'patAcoAccountId',
                                                        width: 100,
                                                    }, {
                                                        Header: props => <span data-inverted="" data-tooltip="Client Account Number" data-position="bottom left">Client Acct#</span>,
                                                        accessor: 'acoInvoiceId',
                                                        minwidth: 100,
                                                    }, {
                                                        Header: props => <span style={{ textAlign: "right" }} data-inverted="" data-tooltip="Principal Balance" data-position="bottom left">Principal</span>,
                                                        id: 'patPrincipal',
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        accessor: row => (
                                                            this.props._currencyFormat(row.patPrincipal)
                                                        )
                                                    }, {
                                                        Header: props => <span style={{ textAlign: "right" }} data-inverted="" data-tooltip="Interest" data-position="bottom left">Interest</span>,
                                                        id: 'patInterest',
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        accessor: row => (
                                                           ((row.patInterest == 'NaN' || row.patAccumulatedInterest == 'NaN') ? '-' : (this.props._currencyFormat(row.patInterest + row.patAccumulatedInterest)))
                                                        )
                                                    }, {
                                                        Header: props => <span style={{ textAlign: "right" }} data-inverted="" data-tooltip="Other Charges" data-position="bottom left">Other Charges</span>,
                                                        id: 'patOtherCharges',
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        accessor: row => (
                                                            (row.patOtherCharges == 'NaN' ? '-' : this.props._currencyFormat(row.patOtherCharges))
                                                        )
                                                    }, {
                                                        Header: props => <span style={{ textAlign: "right" }} data-inverted="" data-tooltip="Penalty / Collection Fee" data-position="bottom right">Penalty</span>,
                                                        id: 'patPenalty',
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        accessor: row => (
                                                            this.props._currencyFormat(row.patPenalty)
                                                        )
                                                    }, {
                                                        Header: props => <span style={{ textAlign: "right" }} data-inverted="" data-tooltip="Attorney Fee" data-position="bottom left">Attorney</span>,
                                                        id: 'patAttorney',
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        accessor: row => (
                                                            (row.patAttorney == 'NaN' ? '-' : this.props._currencyFormat(row.patAttorney))
                                                        )
                                                    }, {
                                                        Header: props => <span style={{ textAlign: "right" }} data-inverted="" data-tooltip="NSF Fee" data-position="bottom left">NSF Fee</span>,
                                                        id: 'patNsfFee',
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        accessor: row => (
                                                            this.props._currencyFormat(row.patNsfFee)
                                                        )
                                                    }, {
                                                        Header: props => <span style={{ textAlign: "right" }} data-inverted="" data-tooltip="Over Payment" data-position="bottom left">Over Payment</span>,
                                                        id: 'patOverpayment',
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        accessor: row => (
                                                            (row.patOverpayment == 'NaN' ? '-' : this.props._currencyFormat(row.patOverpayment))
                                                        )
                                                    },{
                                                        Header: props => <span style={{ textAlign: "right" }} data-inverted="" data-tooltip="CourtCost" data-position="bottom left">Court Cost</span>,
                                                        id: 'patCourtCosts',
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        accessor: row => (
                                                            (row.patCourtCosts == 'NaN' ? '-' : this.props._currencyFormat(row.patCourtCosts))
                                                        )
                                                    }, {
                                                        Header: props => <span style={{ textAlign: "right" }} data-inverted="" data-tooltip="Total Amount allocated on this account" data-position="bottom left">Total Paid</span>,
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        Cell: row => (
                                                            this.props._currencyFormat(row.original.totalPaymentAllocated)
                                                        )
                                                    }, {
                                                        Header: props => <span style={{ textAlign: "right" }} data-inverted="" data-tooltip="Current Total Due" data-position="bottom left">Invoice</span>,
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        id: 'patTrustBatchNo',
                                                        width: 100,
                                                        accessor: row => (
                                                            row.patTrustBatchNo > 0 ? row.patTrustBatchNo : "-"
                                                        )
                                                    }, {
                                                        Header: props => <span data-inverted="" data-tooltip="Authorized User" data-position="bottom left">Processed User</span>,
                                                        accessor: 'patAuthUser',
                                                        width: 100
                                                    }]}
                                                />
                                            </Segment>
                                        </Segment.Group>
                                    );
                                }
                            }
                            columns={
                                [{
                                    expander: true,
                                    Header: props => <span data-inverted=""
                                        data-tooltip={this.props.t("view.payment.details")}
                                        data-position="bottom left">#
                                </span>,
                                    Expander: ({ isExpanded, ...rest }) =>
                                        <div>
                                            {
                                                isExpanded
                                                    ? <Icon className="arrow alternate circle down icon"></Icon>
                                                    : <Icon className="arrow alternate circle right icon"></Icon>
                                            }
                                        </div>,
                                    style: {
                                        cursor: "pointer"
                                    }
                                }, {
                                    Header: props => <span data-inverted="" data-tooltip="Transaction Ref Number" data-position="bottom left">Payment Id#</span>,
                                    accessor: 'payPaymentId',
                                    width: 150
                                }, {
                                    Header: props => <span data-inverted="" data-tooltip="Date of Payment" data-position="bottom left">Payment Date</span>,
                                    id: 'conditionalDate',
                                    width: 150,
                                    style: {
                                        textAlign: "center"
                                    },
                                    accessor: row => (
                                        row.payAuthDate !== null ? this.props._timeStampToNonFormatDate(row.payAuthDate) : this.props._timeStampToNonFormatDate(row.payTimestamp)
                                    )
                                }, {
                                    Header: props => <span data-inverted="" data-tooltip="Payment Notes" data-position="bottom left">Payment Desc</span>,
                                    accessor: 'payDescription',
                                    width: 300
                                }, {
                                    Header: props => <span data-inverted="" data-tooltip="Type of Payment" data-position="bottom left">Payment Type</span>,
                                    id: 'payPmtTypeId',
                                    width: 150,
                                    accessor: row => (
                                        /** Adding hardcoded since these are used globally in ARTrail systems */
                                        row.payPmtTypeId === 254 ? "Paid You" : row.payPmtTypeId === 667 ? "Adjusted" : "Paid Us"
                                    )
                                },/* {
                                    Header: props => <span data-inverted="" data-tooltip="Total Amount Paid" data-position="bottom left">Payment Amount</span>,
                                    id: 'payAmount',
                                    width: 150,
                                    style: {
                                        textAlign: "right"
                                    },
                                    accessor: row => (
                                        this.props._currencyFormat(row.payAmount)
                                    )
                                },*/ {
                                    Header: props => <span data-inverted="" data-tooltip="Current Status of Payment " data-position="bottom left">Payment Status</span>,
                                    id: 'payEntryStatus',
                                    accessor: row => (
                                        row.payAuthDate !== null ? row.payEntryStatus === 'R' ? "Reversed" : "Posted" : "Pending"
                                    )
                                }, {
                                    Header: props => <span data-inverted="" data-tooltip="Payment Processed User" data-position="bottom left">Processed User</span>,
                                    accessor: 'payAuthUser'
                                }]}
                        />
                    )
                }
            },
            {
                menuItem: (
                    <Menu.Item key='title2'>
                        Consumer History
                    </Menu.Item>
                ),
                pane: {
                    key: 'second', content: (
                        <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.props.consumerHistory && this.props.consumerHistory.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                            data={this.props.consumerHistory}
                            getNoDataProps={() => {
                                return { style: { display: 'none' } };
                            }}
                            columns={[{
                                Header: 'Date & Time',
                                accessor: 'cmmDateTime',
                                width: 160
                            }, {
                                Header: 'Acct#',
                                accessor: 'cmmAccountId',
                                width: 150
                            }, {
                                Header: 'Notes',
                                accessor: 'cmmComment',
                                style: {
                                    textAlign: "left"
                                }

                            }, {
                                Header: 'Type',
                                accessor: 'cmmType',
                                width: 100
                            }]}
                        />
                    ), textAlign: 'center'
                },
            },
            {
                menuItem: (
                    <Menu.Item key='title3'>
                        Dialer History
                    </Menu.Item>
                ),
                pane: {
                    key: 'third', content: (
                        <div>
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column width={16}>
                                        <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.props.dialerHistory && (this.props.dialerHistory.length > this.props.reactTable().pageSize) ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                                            data={this.props.dialerHistory}
                                            getNoDataProps={() => {
                                                return { style: { display: 'none' } };
                                            }}
                                            columns={[{
                                                Header: 'Call#',
                                                accessor: 'dlrCall'
                                            }, {
                                                Header: 'Call Status',
                                                accessor: 'dlrStatus',
                                            }, {
                                                Header: 'Campaign ID',
                                                accessor: 'dlrCampaignId',
                                            }, {
                                                Header: 'Campaign Name',
                                                accessor: 'dlrCampaignName',
                                            }, {
                                                Header: 'List Name',
                                                accessor: 'dlrListName'
                                            }, {
                                                Header: 'User',
                                                accessor: 'dlrUser'
                                            }, {
                                                Header: 'Requested Date',
                                                accessor: 'dlrRequestedDate',
                                            }, {
                                                Header: 'Date / Time Dialed',
                                                accessor: 'dlrDateTimeDialed',
                                            }, {
                                                Header: 'Call Type',
                                                accessor: 'dlrCallType',
                                            }]}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </div>
                    ), textAlign: 'center'
                }
            }
        ];
        return (
            <div>
                <Segment.Group raised>
                    <Segment className="grey" inverted>
                        <Header as="h4"><Icon className="search"></Icon>Account History</Header>
                    </Segment>
                    <Segment>
                        <Tab panes={panes} renderActiveOnly={false} />
                    </Segment>
                </Segment.Group>
                <Modal open={this.state.openDocument} onClose={this.closeDocument} closeIcon>
                    <Modal.Header>Upload Document(s) for the selected account</Modal.Header>
                    <Documents acoAccountId={this.state.documentAccountId} {...this.props} />
                </Modal>
            </div>
        );
    }
}
export default History;


// WEBPACK FOOTER //
// ./src/app/ui/accounts/History.js